import * as amplitude from '@amplitude/analytics-browser';

function initAmplitude() {
  const serverUrl = import.meta.env.VITE_AMPLITUDE_API_URL;
  if (typeof window !== 'undefined' && typeof serverUrl !== 'undefined') {
    amplitude.init('4c114f894b29fa020edfdac9d1f10852', {
      autocapture: true,
      serverUrl,
      // Utiliser le proxy au lieu de serverZone: 'EU'
    });
  }
}

initAmplitude();

export const Amplitude = () => null;
export default amplitude;
